<template>
  <ItemPage
    title="Questões"
    size="md"
    :actions="actions"
  >
    <template
      v-if="questionsView"
    >
      <QuestionFilters
        @setParameters="parameters = $event; newFilter()"
      />

      <div class="py-1">
        <template v-if="loading">
          <Load :loading-msg="'Carregando'" />
        </template>
        <div v-else>
          <div
            v-for="question in questions"
            :key="question.id"
          >
            <div class="my-8">
              <div class="grey lighten-5 px-5 py-3 rounded">
                <router-link :to="{ name: 'conteudos.questoes.id', params: { id: question.id } }">
                  Questão #{{ question.id }}
                </router-link>
                <span
                  v-if="question.intranet_user"
                  class="ml-3"
                >
                  Criada por {{ question.intranet_user.name }} {{ dayjs(question.created_at).fromNow() }}
                </span>
              </div>
              <div class="px-5">
                <editor-content
                  v-if="question.editor"
                  :editor="question.editor"
                  class="editor-content mt-5"
                />
                <div
                  v-else
                  class="red--text"
                >
                  Conteúdo corrompido! Apague esta questão e cadastre-a novamente.
                </div>
              </div>
            </div>

            <v-divider />
          </div>
        </div>
      </div>

      <v-pagination
        v-model="page"
        :length="totalPages"
        :total-visible="5"
        class="mt-4"
      />
    </template>
    <template v-else>
      usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import utils from '@/api/utils.js'
import ItemPage from '@/components/pages/ItemPage.vue'
import { Editor, EditorContent } from 'tiptap'
import {
  HardBreak,
  Bold,
  Italic,
  History
} from 'tiptap-extensions'
import Image from '@/components/contents/questions/editor/nodes/Image'
import Katex from '@/components/contents/questions/editor/nodes/Katex'
import dayjs from '@/dayjs'
import QuestionFilters from '@/components/contents/QuestionFilters.vue'

export default {
  components: {
    Load,
    EditorContent,
    ItemPage,
    QuestionFilters
  },

  data: () => ({
    loading: true,
    questionsView: false,
    questionsCreate: false,
    disabledBtn: true,

    // Questions
    questions: [],

    // Pagination
    page: 1,
    totalPages: 1,

    // Filters

    parameters: null
  }),

  computed: {
    actions () {
      return [
        {
          label: 'Criar Questão',
          action: this.createNewQuestion,
          icon: 'mdi-plus',
          disabled: !this.questionsCreate
        }
      ]
    }
  },
  watch: {
    page (value) {
      this.fetchPage()
    }

  },

  async created () {
    this.fetchPage(1)
  },

  methods: {
    newFilter () {
      console.log(this.parameters)
      this.fetchPage()
    },
    async fetchPage () {
      this.questionsView = utils.checkAnyOrOwn('questions.view-any', 'questions.view-own')
      this.questionsCreate = utils.checkPermissions('questions.create')
      this.loading = true

      // const query = [`page=${page}`, 'with=intranetUser']

      // if (this.topic) {
      //   query.push(`topic_id=${this.topic}`)
      // } else if (this.subject) {
      //   query.push(`subject_id=${this.subject}`)
      //   query.push(`grade_level_id=${this.gradeLevel}`)
      // }

      // if (!this.topic && this.teachingSystem) {
      //   query.push(`teaching_system_id=${this.teachingSystem}`)
      // }

      const data = await this.$api.listQuestions(this.page, this.parameters ? this.parameters : '')

      for (const question of data.data) {
        try {
          question.editor = new Editor({
            editable: false,
            extensions: [
              new HardBreak(),
              new Bold(),
              new Image(),
              new Italic(),
              new History(),
              new Katex()
            ],
            content: JSON.parse(question.text_data).statement
          })
        } catch (e) {
          question.editor = null
        }
      }

      if (this.questions.length > 0) {
        for (const question of this.questions) {
          question.editor && question.editor.destroy()
        }
      }

      this.questions = data.data
      this.totalPages = data.meta.last_page

      this.loading = false
    },
    async createNewQuestion () {
      const question = await this.$api.newQuestion()
      this.$router.push({ name: 'conteudos.questoes.id', params: { id: question.id } })
    },

    async filter () {
      this.busy = true
      this.fetchPage()
      this.busy = false
    },

    dayjs
  }
}
</script>
